import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import FixedElementsPortal from './FixedElementsPortal';
import PropTypes from 'prop-types';

// This component wraps other components that should appear in a sticky, bottom-fixed position on mobile devices.
// Prop `setForDesktop`: when `true`, the wrapped component will also behave as a sticky element on desktop,
// but instead of sticking to the bottom, it sticks to the top after being scrolled past.
// The current implementation supports basic sticky behavior for mobile.
// To use it on desktop freely, more enhancements (eg. setting up margins via props instead of hard-coded value) are needed.

const ResponsiveFixedPortalWrapper = ({ setForDesktop, children, valueToAdjustTop, isMarathonFoto }) => {
  const [isSmallDevice, setIsSmallDevice] = useState(window.innerWidth <= 768);
  const [showStickyForDesktop, setShowStickyForDesktop] = useState(false);
  const [pointToStickOnDesktop, setPointToStickOnDesktop] = useState();
  const [originalElementHeight, setOriginalElementHeight] = useState();

  const containerRef = useRef(null);
  useLayoutEffect(() => {
    if (setForDesktop && containerRef.current) {
      // adjustement is related to: nav height + padding top
     const navHeight = isMarathonFoto ? 0 : 90;
     setPointToStickOnDesktop(
       containerRef.current.getBoundingClientRect().top - navHeight - valueToAdjustTop
     );
      setOriginalElementHeight(containerRef.current.clientHeight);
    }
  }, [containerRef]);

  useEffect(() => {
    if (setForDesktop) {
      const handleScroll = () => {
        if (window.pageYOffset > pointToStickOnDesktop) {
          setShowStickyForDesktop(true);
        } else if (setShowStickyForDesktop) {
          setShowStickyForDesktop(false);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  });

  useEffect(() => {
    const handleWindowSizeChange = () => {
      const newWidth = window.innerWidth;
      setIsSmallDevice(newWidth <= 768);
    };

    window.addEventListener('resize', handleWindowSizeChange);

    handleWindowSizeChange();

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  // note: to avoid flashy effect on desktop, div of height of the element + its padding is added
  return isSmallDevice || showStickyForDesktop ? (
    <>
      {showStickyForDesktop && !isSmallDevice && (
        <div style={{ height: `${originalElementHeight + 40}px`, width: '100%' }}></div>
      )}
      <FixedElementsPortal id="responsive-portal" isMobileLayout={isSmallDevice} isMarathonFoto={isMarathonFoto}>
        {children}
      </FixedElementsPortal>
    </>
  ) : (
    <div ref={containerRef} className="mb-40">
      {children}
    </div>
  );
};

ResponsiveFixedPortalWrapper.propTypes = {
  setForDesktop: PropTypes.bool,
  children: PropTypes.node,
  valueToAdjustTop: PropTypes.number,
  isMarathonFoto: PropTypes.bool,
};

export default ResponsiveFixedPortalWrapper;
